import React from 'react';
import {
  FaChalkboardTeacher,
  FaUsers,
  FaLaptopCode,
  FaCertificate,
  FaGraduationCap,
  FaBriefcase,
} from 'react-icons/fa';

const pillars = [
  {
    icon: FaChalkboardTeacher,
    title: 'Expert Faculty',
    body: 'Learn from industry professionals with years of real-world experience who are passionate about teaching and mentoring the next generation of tech talent.',
  },
  {
    icon: FaUsers,
    title: 'Diverse Community',
    body: 'Join a vibrant and inclusive network of learners and professionals where collaboration and knowledge sharing create opportunities for growth.',
  },
  {
    icon: FaLaptopCode,
    title: 'Practical Learning',
    body: 'Engage in hands-on projects and real-world applications that develop the practical skills employers actually value.',
  },
  {
    icon: FaCertificate,
    title: 'Industry Certification',
    body: 'Earn recognised certifications that validate your skills and knowledge, enhancing your credibility with potential employers.',
  },
  {
    icon: FaGraduationCap,
    title: 'Flexible Learning',
    body: 'Access courses on a schedule that works around you, so you can balance study with work and personal commitments.',
  },
  {
    icon: FaBriefcase,
    title: 'Career Support',
    body: 'Benefit from career counselling, job placement assistance and networking that helps you move from learning to earning.',
  },
];

const About = () => {
  return (
    <div className="container-page">
      <div className="max-w-2xl">
        <span className="eyebrow">Our Story</span>
        <h2 className="section-title">About AC Tech Institute</h2>
        <p className="section-lead">
          We are a tech institute dedicated to high-quality, practical courses. Our mission is to
          equip students with real-world skills that drive innovation and success.
        </p>
      </div>

      <div className="mt-14 grid gap-px overflow-hidden rounded-xl border border-surface-line bg-surface-line sm:grid-cols-2 lg:grid-cols-3">
        {pillars.map(({ icon: Icon, title, body }) => (
          <div
            key={title}
            className="group bg-surface-raised p-8 transition-colors duration-200 hover:bg-surface-base"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-surface-line bg-surface-base text-brand-400 transition-colors duration-200 group-hover:border-brand-500/50 group-hover:text-brand-300">
              <Icon className="h-5 w-5" />
            </span>
            <h3 className="mt-6 text-base font-semibold text-ink">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-ink-muted">{body}</p>
          </div>
        ))}
      </div>

      {/* Mission */}
      <div className="mt-16 grid gap-10 border-t border-surface-line pt-16 md:grid-cols-[auto_1fr] md:gap-16">
        <h3 className="text-xl font-semibold text-ink md:w-40">Our Mission</h3>
        <div className="max-w-3xl space-y-5 text-sm leading-relaxed text-ink-muted md:text-base">
          <p>
            At AC Tech Institute, we are committed to providing accessible, high-quality education
            that empowers individuals to achieve their professional goals and contribute
            meaningfully to the technological advancement of society.
          </p>
          <p>
            Through innovative teaching methods, industry partnerships and a supportive learning
            environment, we strive to be the bridge that connects aspiring professionals with the
            skills they need for the careers they want.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
